import { render, staticRenderFns } from "./case_studies.vue?vue&type=template&id=d9d2639a&scoped=true&"
import script from "./case_studies.vue?vue&type=script&lang=js&"
export * from "./case_studies.vue?vue&type=script&lang=js&"
import style0 from "./case_studies.vue?vue&type=style&index=0&id=d9d2639a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d2639a",
  null
  
)

export default component.exports